import type { CallbackResponse } from '../hooks/useZuoraLibrary';

export type CallbackState = 'success' | 'failed_submission' | 'failed_load';

export const emitCallbackEvents =
  (emit: (state: CallbackState, reponse: CallbackResponse) => void) =>
  (response: CallbackResponse): void => {
    if (response.success) {
      emit('success', response);
    }

    if (!response.success) {
      if (response.responseFrom === 'Response_From_Submit_Page') {
        // Handle the error response when the Payment Page submission failed.
        emit('failed_submission', response);
      } else {
        // Handle the error response when the Payment Page request failed.
        emit('failed_load', response);
      }
    }
  };
